import { render, staticRenderFns } from "./show.profile-review.page.vue?vue&type=template&id=63b8b43a&scoped=true&"
import script from "./show.profile-review.page.vue?vue&type=script&lang=js&"
export * from "./show.profile-review.page.vue?vue&type=script&lang=js&"
import style0 from "./show.profile-review.page.vue?vue&type=style&index=0&id=63b8b43a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8b43a",
  null
  
)

export default component.exports